import { render, staticRenderFns } from "./AboutRenedian.vue?vue&type=template&id=707dc5d2"
import script from "./AboutRenedian.vue?vue&type=script&lang=js"
export * from "./AboutRenedian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports